export class CodigoDeChamada {
    nomeDaOperadora: string
    bandeira: string
    vendaCredito: string
    vendaDebito: string

    recebimentoLiquidoCredito?: string
    recebimentoLiquidoDebito?: string
    taxaOperadoraCredito?: string
    taxaOperadoraDebito?: string
    estornoDeVendasCredito?: string
    estornoDeVendasDebito?: string
    antecipacaoTaxa?: string
    aluguel?: string
    outrosAjustes?: string
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/codigo-de-chamada.model.ts